import React, { useState } from 'react';
import { Alert, Box, TextField } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/**
 * ADR-136 phase 6 (§15 slice 3) — Cancel Scheduled Renewal modal body.
 *
 * The B2 pattern applied to a scheduled replacement: the pending
 * RENEWAL_SCHEDULED flips to Cancelled and a Valid cancellation event records
 * who/when/why. Nothing else changes, because scheduling changed nothing.
 */
// ADR-187 — `cutoverOn` is the cutover of the renewal being cancelled (the
// acting contract's), not the person view's pendingRenewal (the primary's).
const EmployeeCancelScheduledRenewal = ({ cutoverOn = null, onValidChange }) => {
  const [formData, setFormData] = useState({
    reason: ''
  });

  const [touched, setTouched] = useState({
    reason: false
  });

  const cutover = cutoverOn ? dayjs.utc(cutoverOn).format('DD/MM/YYYY') : null;

  const handleInputChange = (field) => (event) => {
    const newFormData = {
      ...formData,
      [field]: event.target.value
    };
    setFormData(newFormData);
    setTouched(prev => ({
      ...prev,
      [field]: true
    }));

    // Valid if reason is provided
    const isValid = event.target.value.trim().length > 0;
    onValidChange(isValid, newFormData);
  };

  const shouldShowError = (field) => {
    return touched[field];
  };

  React.useEffect(() => {
    // Initialize as invalid
    onValidChange(false, formData);
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
        <Alert severity="info">
          This <strong>removes the contract replacement scheduled
          for {cutover || 'a future date'}</strong>: the pending renewal is cancelled and
          the current contract simply continues as it is. Nothing else changes —
          scheduling changed nothing, so there is nothing to undo. To replace the
          contract on a different date, cancel here first and schedule again.
        </Alert>
        <TextField
          fullWidth
          label="Reason"
          value={formData.reason}
          onChange={handleInputChange('reason')}
          multiline
          rows={4}
          required
          error={shouldShowError('reason') && !formData.reason}
          helperText={shouldShowError('reason') && !formData.reason
            ? 'Reason is required'
            : 'Reason for cancelling the scheduled replacement (kept on the cancellation record)'}
          placeholder="Enter reason for cancelling..."
        />
      </Box>
    </Box>
  );
};

export default EmployeeCancelScheduledRenewal;
